<ng-container>
    <div class="d-flex justify-content-between align-items-center">
        <div style="margin-bottom: 10px;">
            <!-- <h2>{{pageLabel}}</h2>
            <span id="span1" *ngIf="showSelectedGridDataCountText">{{selectedGridDataCountText}}</span>
            <span id="span2" class="cursor-pointer" *ngIf="showTotalGirdDataCountText"
                (click)="onSelectTotalGridData()">Select all {{totalGirdDataCountText}} instead</span>
            <span id="span2" class="cursor-pointer" *ngIf="showClearSelection" (click)="onClearSelection()">Clear
                selection</span> -->
        </div>
        <div>
            <button *ngIf="showDynamicQueryButton" type="button" class="btn btn-primary" id="openPopupButton"
                (click)="openDynamicQueryModal()">
                FILTERS({{dynamicQueryFilters?.rules?.length ?? 0}}) <i class="fa fa-plus-circle"
                    aria-hidden="true"></i>
            </button>
        </div>
    </div>

    <div class="table-container" id="configurationIssueContainer">
        <!-- <div class="table-container"> -->
        <table *ngIf="gridData.length > 0" class="table table-striped table-bordered" id="dataTable">
            <thead class="fixed-header">
                <tr class="cursor-pointer">
                    <ng-container *ngFor="let column of gridHeaderMap">
                        <th scope="col" *ngIf="column.key !== 'id'">
                            {{ column.name }}
                        </th>
                    </ng-container>
                    <th scope="col" *ngIf="showAddColumn || showEditColumn || showDeleteColumn"></th>
                    <!-- <th scope="col" *ngIf="showDeleteColumn"></th> -->
                    <th scope="col" *ngIf="showActionsColumn">Actions</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let item of gridData">
                    <tr class="pointer">
                        <!-- <td>{{user.email}}</td>
                    <td>{{roleDisplayNameMap[user.role] || 'Invalid Role'}}</td>
                    <td>{{user.is_active ? 'Active' : 'Inactive'}}</td>
                    <td>{{user.created_on | date: 'MM-dd-yyyy'}}</td> -->
                        <ng-container *ngFor="let field of gridColumnList">
                            <td *ngIf="!showFields(field)"
                                [ngStyle]="{'text-align': isNumber(item[field]) ? 'right': 'left'}">
                                <ng-container *ngIf="isDate(item[field]); else currencyFormat">
                                    {{ item[field] | date: 'MM/dd/yyyy' }}
                                </ng-container>

                                <ng-template #currencyFormat>
                                    <ng-container *ngIf="isCurrency(field); else decimalFormat">
                                        {{ item[field] | currency:'USD':'symbol':'1.2-2' }}
                                    </ng-container>

                                    <ng-template #decimalFormat>
                                        <ng-container *ngIf="shouldFormatValue(field); else noFormatDisplay">
                                            {{ formatValues(item[field]) }}
                                        </ng-container>

                                        <ng-template #noFormatDisplay>
                                            {{ item[field] | decimalFormat }}
                                        </ng-template>
                                    </ng-template>
                                </ng-template>
                                <p *ngIf="item[field] == null || item[field] == ''">
                                    <span>_</span>
                                </p>
                                <span *ngIf="field == 'api_token'">
                                    &nbsp;<i class="fa-solid fa-copy cursor-pointer" aria-hidden="true"
                                        (click)="onCopyClick(item)"></i>
                                </span>
                            </td>
                        </ng-container>
                        <td *ngIf="showAddColumn || showEditColumn || showDeleteColumn" style="text-align: center;">
                            <i *ngIf="showAddColumn" class="fa-solid fa-plus cursor-pointer" (click)="onAddClick(item)"
                                style="margin-right: 50px;"></i>
                            <i *ngIf="showEditColumn" class="fa-solid fa-pencil cursor-pointer"
                                (click)="onEditClick(item)" style="margin-right: 50px;"></i>
                            <i *ngIf="showDeleteColumn" class="fa-solid fa-trash-can cursor-pointer"
                                (click)="onDeleteClick(item)"></i>
                        </td>
                        <!-- <td *ngIf="showDeleteColumn" style="text-align: center;">
                        <i class="fa-solid fa-trash-can cursor-pointer" (click)="onDeleteClick(item)"></i>
                    </td> -->
                        <td *ngIf="showActionsColumn">
                            <select name="action" id="action" class="form-control form-control-lg action-select"
                                style="appearance: auto;" [(ngModel)]="item.selectedAction"
                                (change)="onActionChange($event.target, item)">

                                <option selected hidden value="-1">Action</option>
                                <option *ngFor="let action of actionDropdownConfig" [value]="action.value"
                                    [hidden]="!action.condition(item)">
                                    {{ action.label }}
                                </option>
                            </select>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>

    <!-- <div *ngIf="gridData.length > 0 && total > 0" class="pagination-controls fixed-pagination">
        <div>
            <span>Show rows per page: </span>
            <select class="cursor-pointer" [(ngModel)]="paginationData.pageSize"
                (ngModelChange)="onPageSizeChange($event)">
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="75">75</option>
                <option value="100">100</option>
            </select>
        </div>
        <div class="pagination-info">
            <span id="numberspan">{{startItemCount}} - {{endItemCount}} of {{total}}</span>
            <ngb-pagination [collectionSize]="total" [(page)]="paginationData.currentPage"
                [pageSize]="paginationData.pageSize" [maxSize]="5" (pageChange)="onPaginationChange($event)">
            </ngb-pagination>
        </div>
    </div> -->

</ng-container>

<div *ngIf="gridData.length>0 && total>0" class="pagination-controls">
    <div>
        <span>Show rows per page: </span>
        <select class="cursor-pointer" [(ngModel)]="paginationData.pageSize" (ngModelChange)="onPageSizeChange($event)">
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="75">75</option>
            <option value="100">100</option>
        </select>
    </div>
    <div class="pagination-info">
        <span id="numberspan">{{startItemCount}} - {{endItemCount}} of {{total}}</span>
        <ngb-pagination [collectionSize]="total" [(page)]="paginationData.currentPage"
            [pageSize]="paginationData.pageSize" [maxSize]="5" (pageChange)="onPaginationChange($event)">
        </ngb-pagination>
    </div>
</div>





<span *ngIf="gridData.length<1">
    {{noGridDataMessage}}
</span>